import React, { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import {ReactComponent as ErrorIcon} from '../../../img/error.svg';
import {ReactComponent as WhiteSuccessIcon} from '../../../img/success-white.svg';
import {ReactComponent as SuccessIcon} from '../../../img/success.svg';
import {ReactComponent as WhiteErrorIcon} from '../../../img/error-white.svg';


const iconProcessing =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' style='width:24px;height:24px' viewBox='0 0 24 24'%3E%3Cpath fill='%23013BAE' d='M4 2A2 2 0 0 0 2 4V20A2 2 0 0 0 4 22H12.41A7 7 0 0 0 16 23A7 7 0 0 0 23 16A7 7 0 0 0 18 9.3V8L12 2H4M4 4H11V9H16A7 7 0 0 0 9 16A7 7 0 0 0 10.26 20H4V4M16 11A5 5 0 0 1 21 16A5 5 0 0 1 16 21A5 5 0 0 1 11 16A5 5 0 0 1 16 11M15 12V17L18.61 19.16L19.36 17.94L16.5 16.25V12H15Z' /%3E%3C/svg%3E";


interface StatusFileIconProps {
  fileUri?: string;
  error?: Error | undefined;
}

const StatusFileIcon =  ({ fileUri, error } : StatusFileIconProps) => {
  const theme = useTheme();
  const colorMode = theme.palette.mode;
  const { t } = useTranslation();

  const getFileStatus = () => {
    if (fileUri) return t('export.success');
    if (error) return t('export.error');
    return 'export.processing';
};
  
  const iconSx: CSSProperties = {
    width: '20px',
    height: '20px',
    marginRight: '10px',
  };

  if (fileUri) {
    return colorMode === 'light' ? (
      <SuccessIcon style={iconSx} />
    ) : (
      <WhiteSuccessIcon style={iconSx} />
    );
  }

  if (error) {
    return colorMode === 'light' ? (
      <ErrorIcon style={iconSx} />
    ) : (
      <WhiteErrorIcon style={iconSx} />
    );
  }

  return <img src={iconProcessing} alt={getFileStatus()} style={iconSx} />;
};

export default StatusFileIcon;
